import { render, staticRenderFns } from "./AssignInBulkModal.vue?vue&type=template&id=3f0defb2"
import script from "./AssignInBulkModal.vue?vue&type=script&lang=js"
export * from "./AssignInBulkModal.vue?vue&type=script&lang=js"
import style0 from "./AssignInBulkModal.vue?vue&type=style&index=0&id=3f0defb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports